"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var graphql_ld_1 = require("graphql-ld");

var graphql_ld_comunica_solid_1 = require("graphql-ld-comunica-solid");

var prop_types_1 = require("prop-types");

var react_1 = __importDefault(require("react"));

var ts_invariant_1 = __importDefault(require("ts-invariant"));

var GraphQlLdContext_1 = require("../context/GraphQlLdContext");
/**
 * A provider component for defining a GraphQL-LD query engine.
 * @param {GraphQlLdProviderArgs} args Options for a GraphQL-LD query engine.
 * @return {any}
 * @constructor
 */


function GraphQlLdProvider(args) {
  var GraphQlLdContext = GraphQlLdContext_1.getGraphQlLdContext();
  var client = 'client' in args ? args.client : new graphql_ld_1.Client({
    baseIri: args.baseIri,
    context: [require('@solid/context'), args.context || {}],
    queryEngine: new graphql_ld_comunica_solid_1.QueryEngineComunicaSolid({
      sources: args.sources
    })
  });
  return react_1.default.createElement(GraphQlLdContext.Consumer, null, function () {
    var graphQlLdContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (client && graphQlLdContext.client !== client) {
      graphQlLdContext = Object.assign(Object.assign({}, graphQlLdContext), {
        client: client
      });
    } // Error if no client has been set


    ts_invariant_1.default(graphQlLdContext.client, 'GraphQlLdProvider was not passed a client instance or sources list. ' + 'Make sure you pass in your client via the "client" prop, or a list of sources via the "sources" prop.');
    return react_1.default.createElement(GraphQlLdContext.Provider, {
      value: graphQlLdContext
    }, args.children);
  });
}

exports.GraphQlLdProvider = GraphQlLdProvider;

(function (GraphQlLdProvider) {
  GraphQlLdProvider.propTypes = {
    baseIri: prop_types_1.string,
    client: prop_types_1.object,
    context: prop_types_1.object,
    sources: prop_types_1.arrayOf(prop_types_1.oneOfType([prop_types_1.string, prop_types_1.object]))
  };
})(GraphQlLdProvider = exports.GraphQlLdProvider || (exports.GraphQlLdProvider = {}));